import { render, staticRenderFns } from "./CompanyPlanningsBlock.vue?vue&type=template&id=645f8262"
import script from "./CompanyPlanningsBlock.vue?vue&type=script&lang=js"
export * from "./CompanyPlanningsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports